module.exports = __webpack_public_path__ + "img/quote.9606fcfe.svg";